import { createFiltersInstance } from "modules/utils/createFilteredItemsInstance";

const createProductsFiltersInstance = ({ SET_FILTERS, getInitialFilters = () => ({}) }) =>
  createFiltersInstance({
    SET_FILTERS,
    initialFilters: {
      id: null,
      supplier_id: null,
      location_names: null,
      product_type: null,
      search: null,
      ...getInitialFilters(),
    },
    filterTypes: {
      id: "Number",
      supplier_id: "Number",
      location_names: "String",
      product_type: "String",
      search: "String",
    },
  });

export default createProductsFiltersInstance;



// WEBPACK FOOTER //
// ./src/modules/products/ProductsListView/createProductsFiltersInstance.js